import { modals } from '@mantine/modals'
import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'
import { showSuccessNotification } from '@v2/domains/notification/notification.hook'

import { useDeleteTagMutation } from '../api/tag.api'

const useDeleteTag = () => {
  const [deleteTagMutation, { status }] = useDeleteTagMutation()

  const deleteTag = async (tagId: string): Promise<boolean> => {
    try {
      await deleteTagMutation(tagId).unwrap()
      showSuccessNotification('Tag succesfuly deleted!')
      modals.closeAll()
      return true
    } catch (err: any) {
      handleMutationError(err, 'Error deleting Tag')
      return false
    }
  }

  return {
    deleteTag,
    deleteMutationStatus: status,
  }
}
export default useDeleteTag
